import { Link } from "react-router-dom";
import { serviceAreas } from "@/data/serviceAreas";
import { MapPin } from "lucide-react";

export default function AreaMarquee() {
  const items = [...serviceAreas, ...serviceAreas];

  return (
    <div className="overflow-hidden py-3 relative">
      {/* Fade edges matching parent bg */}
      <div className="absolute left-0 top-0 bottom-0 w-12 md:w-24 bg-gradient-to-r from-warm-white to-transparent z-10 pointer-events-none" />
      <div className="absolute right-0 top-0 bottom-0 w-12 md:w-24 bg-gradient-to-l from-warm-white to-transparent z-10 pointer-events-none" />

      <div className="flex gap-3 animate-marquee whitespace-nowrap will-change-transform">
        {items.map((area, i) => (
          <Link
            key={`${area.slug}-${i}`}
            to={`/areas/${area.slug}`}
            className="inline-flex items-center gap-1.5 bg-accent/50 hover:bg-accent rounded-full px-4 py-2 text-xs font-bold text-accent-foreground transition-colors shrink-0 border border-primary/10"
          >
            <MapPin className="w-3.5 h-3.5" />
            {area.name}
          </Link>
        ))}
      </div>
    </div>
  );
}
